import React from "react";

export default function PageHeader({ title, subtitle, eyebrow, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
      <div>
        {eyebrow && (
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#C85A32] font-semibold mb-2">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display font-bold text-4xl sm:text-5xl text-[#1A1A1A] tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-[#595959] mt-2 text-sm sm:text-base max-w-xl">
            {subtitle}
          </p>
        )}
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}
